module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/hip-9b0a72d8d3ea9e9363d78d6eac14c373.png";